<mat-card class="as-address-card as-font">
  <div class="as-row as-justify-sb">
    <div class="as-address-name as-pointer" (click)="onEdit()">
      <mat-icon svgIcon="ic-address"></mat-icon>
      <mat-label class="as-font-semibold as-align-center">
        {{ data.tag }}
      </mat-label>
    </div>
    <mat-icon
      svgIcon="ic-star-{{ data.default ? 'on' : 'off' }}"
      class="as-pointer"
      (click)="onSetAsDefault()"
    >
    </mat-icon>
  </div>
  <br />
  <mat-label class="as-font-14 as-pointer" (click)="onEdit()">
    {{ data.detail
    }}<!-- {{ data.number }}, {{ data.suburb }}, {{ data.zipcode }} {{ data.city }}, {{ data.state }}-->.
  </mat-label>
  <br />
  <br />
  <div class="as-row as-justify-sb as-align-end">
    <mat-label class="as-font-12 as-pointer" (click)="onEdit()">
      {{ data.receiver }}
    </mat-label>
    <mat-icon
      svgIcon="ic-trash"
      class="as-pointer as-gray-icon"
      (click)="onDelete()"
    ></mat-icon>
  </div>
</mat-card>
